/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Target_LocationInputs */



/**
* | output |
* | --- |
* | "Target Backup Location" |
*
* @param {Options_Backup_Target_LocationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_target_location = /** @type {((inputs?: Options_Backup_Target_LocationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Target_LocationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Emplacement cible des sauvegardes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ziel-Sicherungsort")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione di backup di destinazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Целевое место резервного копирования")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ubicación de copia de seguridad de destino")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("目标备份位置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ターゲットバックアップ場所")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लक्ष्य बैकअप स्थान")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Local de backup de destino")
	return /** @type {LocalizedString} */ ("Target Backup Location")
});